import type { Ref } from 'vue';
import { watchEffect } from 'vue';
import type { FormConfig } from '../form/types';

/*
 * @Description:
 * @Author: luckymiaow
 * @Date: 2022-05-25 11:28:53
 * @LastEditors: Ztq
 */

export default (bind: Ref<FormConfig & { style?: Partial<CSSStyleDeclaration> }>) => {
  watchEffect(() => {
    if (bind.value.readOnly === true) {
      if (!('style' in bind.value)) (bind.value as any).style = {};
      bind.value.style!.pointerEvents = 'none';
    } else if ('style' in bind.value) {
      delete bind.value.style!.pointerEvents;
    }
  });
};
